import React from 'react'
import logo from '../../assets/images/Trigger.png'

const AuthBrand = () => (
  <div style={styles.brand}>
    <img src={logo} alt="IKB logo" style={styles.logo} />
    <div style={styles.text}>
      <h1 style={styles.name}>IKB</h1>
      <p style={styles.subtitle}>ProgressArc</p>
    </div>
  </div>
)

const styles = {
  brand: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '14px',
    marginBottom: '32px',
  },
  logo: {
    width: '80px',
    height: '80px',
    flexShrink: 0,
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '2px',
  },
  name: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1e293b',
    margin: 0,
    lineHeight: 1.2,
  },
  subtitle: {
    fontSize: '18px',
    color: '#64748b',
    margin: 0,
  },
}

export default AuthBrand
